@if (ChartData.datasets.length > 0) {
  <canvas baseChart
    [height]="Height"
    [data]="ChartData"
    [options]="ChartOptions"
    [type]="'scatter'">
  </canvas>
}